import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DoubleBookingParsedEvent } from '@models/double-booking.model';

@Component({
	selector: 'event-item',
	template: require('./event-item.component.html'),
	styles: [require('./event-item.component.scss')]
})
export class EventItemComponent {
	@Input() event: DoubleBookingParsedEvent;
	@Output()
	eventEmit: EventEmitter<DoubleBookingParsedEvent> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/event-item/event-item.component.ts